// POST /v1/billing/checkout-session — creates a Stripe Checkout
// Session for either a subscription upgrade or a one-time topup.
// Reducer holds the most recent {url, session_id} so PlansPanel /
// TopUpDialog can window.location.assign() once the call resolves.
//
// The same slice covers both modes (subscription vs payment) since a
// user only ever has one in-flight checkout request at a time.
const action = "BILLING_CHECKOUT";
export const REQUEST  = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE  = action + '_FAILURE';
export const CLEAR    = action + '_CLEAR';

// payload shapes:
//   subscription:  { mode: 'subscription', plan_tier: 'starter', seats: 1 }
//   topup:         { mode: 'payment',      pack_id:  'starter' }
export const startCheckout    = (payload) => ({ type: REQUEST,  payload });
export const checkoutSuccess  = (response) => ({ type: RESPONSE, payload: response });
export const checkoutFailure  = (error)    => ({ type: FAILURE,  payload: error });
export const clearState       = ()          => ({ type: CLEAR });
